// extracted by mini-css-extract-plugin
module.exports = {"introBarContainer":"BaseSingleViewHeader_introBarContainer__fCdLH"};